import { Divider, MenuItem, Typography } from "@mui/material";
import { Lightbulb } from "@mui/icons-material";
import React from "react";

import { ArrangementCreditCostValue } from "./ArrangementCreditCostValue";

export function arrangementCreditCostOptions({ compact }: { compact?: boolean } = { compact: false }) {
  return [
    <MenuItem key={"1"} value={1}>
      <b>Normal cost</b>: 1 credit
    </MenuItem>,
    <MenuItem key={"2"} value={2}>
      <b>High cost</b>: 2 credits
    </MenuItem>,
    <Divider key={"divider"} />,
    <MenuItem key={"outside_arrangements"} value={"-1"}>
      <ArrangementCreditCostValue explanation={!compact} value={-1} />
    </MenuItem>,
    <MenuItem disabled key={"unlimited"} style={{ marginLeft: "8px" }}>
      <Typography variant={"body2"}>
        <span
          style={{
            display: "inline-flex",
            width: "32px",
            height: "32px",
            backgroundColor: "darkgoldenrod",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
        >
          <Lightbulb style={{ color: "yellow", fontSize: "1.2rem", stroke: "black", strokeWidth: "2px" }} />
        </span>
        &nbsp;Use &quot;outside_arrangements&quot; for salt & pepper, sauces, ginger and such as well as for high-margin
        products like drinks
      </Typography>
    </MenuItem>,
    <MenuItem key={"0"} value={0}>
      <ArrangementCreditCostValue explanation={!compact} value={0} />
    </MenuItem>,
    <MenuItem disabled key={"no_cost"} style={{ marginLeft: "8px" }}>
      <Typography variant={"body2"}>
        <span
          style={{
            display: "inline-flex",
            width: "32px",
            height: "32px",
            backgroundColor: "darkgoldenrod",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
        >
          <Lightbulb style={{ color: "yellow", fontSize: "1.2rem", stroke: "black", strokeWidth: "2px" }} />
        </span>
        &nbsp;Use &quot;no cost&quot; for small sides that are not considered part of the arrangement such as fries
      </Typography>
    </MenuItem>,
  ];
}
